import styled from 'styled-components';

import Container from '/components/Container';
import Heading from '/components/ui/Heading';
import Paragraph from '/components/ui/Paragraph';
import { formatPrice } from '/lib/helpers';
import Link from '/components/ui/Link';
import { colors } from '/css';
import PriceType from '/types/priceType';

interface Props {
    isVisible: boolean;
    jobName: string;
    totalCost: PriceType;
}

export default function FloatingPriceInfo({
    isVisible,
    jobName,
    totalCost,
}: Props) {
    return (
        <Wrapper
            className={['pt-24 pb-24', !isVisible ? 'hidden' : ''].join(' ')}
        >
            <Container flex wrap justify="space-between" align="center">
                <Heading medium tag="div">
                    {jobName}
                </Heading>
                <div className="price-info">
                    <Heading medium tag="div">
                        {formatPrice(totalCost.gross)}
                    </Heading>
                    <Paragraph className="price-description" small>
                        <Link purple medium to="/fastpris">
                            Fastprisen
                        </Link>{' '}
                        inkluderer alt og vår <br />
                        bransjeledende SpotOnGaranti™
                    </Paragraph>
                </div>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 999;
    background: ${colors.mintM4};
    height: 110px;
    transition: transform 0.3s ease-in-out;
    display: flex;
    align-items: center;
    @media (max-width: 1024px) {
        height: 70px;
    }
    @media (max-width: 767px) {
        min-height: 70px;
        height: auto;
    }
    &.hidden {
        transform: translateY(100%);
    }
    .price-info {
        * {
            text-align: right;
        }
    }
    .price-description {
        display: none;
        @media (max-width: 1024px) {
            display: none;
        }
    }
`;
